module.exports = __webpack_public_path__ + "img/arrow.9c7e6826.svg";